import { property, supertypeClass } from '@haventech/amorphic';
import { Agent } from './Agent';
import { Everything } from '@hit/amorphic-types/index';
import { AgentProxy } from '../agent/AgentProxy';
import { OpsProxy } from '../agent/OpsProxy';
import { WholesaleProxy } from '../agent/WholesaleProxy';
import { TIME_FILTER_OPTIONS } from '../../../coverpath-agent/public/js/types/Types';
import { TeleInterviewer } from '../agent/TeleInterviewer';

export enum PrincipalType {
  Agent = 'agent',
  Proxy = 'proxy',
  OpsProxy = 'opsProxy',
  WholesaleProxy = 'wholesaleProxy',
  TeleInterviewer = 'teleInterviewer',
}

@supertypeClass({ toClient: true, toServer: true })
export class AgentProfile extends Everything {
  @property()
  pic: string;

  @property()
  title: string;

  @property()
  bio: string;

  @property()
  linkedin: string;

  @property()
  designations: string;

  @property({ toServer: false })
  displayName: string;

  @property()
  examVendor: string;

  @property({ getType: () => Agent })
  agent: Agent;

  @property({ getType: () => Agent, comment: 'for Proxy user only, remember the agent that proxy selected last time' })
  lastSelectedAgent: Agent;

  @property({ getType: () => AgentProxy })
  proxy: AgentProxy;

  @property({ getType: () => OpsProxy })
  opsProxy: OpsProxy;

  @property({ getType: () => WholesaleProxy })
  wholesaleProxy: WholesaleProxy;

  @property({ getType: () => TeleInterviewer })
  teleInterviewer: TeleInterviewer;

  @property({ comment: 'true if the producer set the default exam vendor' })
  hasChoseDefaultExamVendor: boolean = false;

  @property({ comment: 'true if the producer set the default exam vendor' })
  choseNoEmail: boolean = false;

  @property({ comment: 'selected time filter option in agent account center list view' })
  timeFilterSelection: TIME_FILTER_OPTIONS = TIME_FILTER_OPTIONS.ALL;

  /*
   * The agent phone number comes from CDM. Once it's updated by the agent
   * via settings page, don't update it from CDM during login.
   */
  @property({
    values: ['true', 'false'],
    descriptions: { true: 'Yes', false: 'No' },
    comment: 'has the phone number been updated via settings page',
  })
  isPhoneNumberUpdatedByAgent: boolean;

  constructor() {
    super();
  }

  static new(
    principal: Agent | AgentProxy | OpsProxy | WholesaleProxy | TeleInterviewer,
    principalType: PrincipalType
  ) {
    return new AgentProfile().init(principal, principalType);
  }

  init(principal: Agent | AgentProxy | OpsProxy | WholesaleProxy | TeleInterviewer, principalType: PrincipalType) {
    switch (principalType) {
      case PrincipalType.Agent:
        this.agent = principal as Agent;
        break;
      case PrincipalType.Proxy:
        this.proxy = principal as AgentProxy;
        break;
      case PrincipalType.OpsProxy:
        this.opsProxy = principal as OpsProxy;
        break;
      case PrincipalType.WholesaleProxy:
        this.wholesaleProxy = principal as WholesaleProxy;
        break;
      case PrincipalType.TeleInterviewer:
        this.teleInterviewer = principal as TeleInterviewer;
        break;
      default:
        throw Error(`PrincipalType: ${principalType} not found`);
    }
    return this;
  }

  setDisplayName(displayNameFromOkta: string) {
    if (displayNameFromOkta.includes(',')) {
      this.displayName = displayNameFromOkta.substring(displayNameFromOkta.indexOf(',') + 1).trim();
      if (this.displayName.includes('(')) {
        this.displayName = this.displayName.substring(0, this.displayName.indexOf('(')).trim();
      }
    } else {
      this.displayName = '';
    }
  }
}
